import CompanySetupComponent from 'components/Settings/PayrollSettings/CompanySetup';
import PermissionGuard from 'components/Global/PermissionGuard';

export const CompanySetup = () => {
	return (
		<PermissionGuard permission="Allow_Company_Setup">
			<CompanySetupComponent />
		</PermissionGuard>
	);
};
